<fui-checkbox-control [label]="label" [readOnly]="isReadonly" [(ngModel)]="value">
</fui-checkbox-control>
